import * as yup from 'yup';


export const TEXT_LENGTH_MAX = 2000;
export const TEXT_LENGTH_MIN = 10;


export const SCHEMA_FEEDBACK_FORM = yup.object()
    .shape({
        text: yup.string()
            .nullable()
            .max(TEXT_LENGTH_MAX)
            .min(TEXT_LENGTH_MIN)
            .required()
            .freeText()
    });
